import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, switchMap, map, catchError } from 'rxjs/operators';
import * as fromShared from '../../../shared';

import * as IndirectRateCostCenterActions from './indirect-rate-cost-center.actions';
import { IndirectRateService } from '../../indirect-rate.service';
import { ResponseStatus } from '../../../shared';

@Injectable()
export class IndirectRateCostCenterEffects {
    getIndirectRateCostCenters$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateCostCenterActions.getIndirectRateCostCenters),
            switchMap(() =>
                this.service.getIndirectRateCostCenters().pipe(
                    map(resp =>
                        IndirectRateCostCenterActions.loadIndirectRateCostCenters(
                            { indirectRateCostCenters: resp }
                        )
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    putIndirectRateCostCentersStatusUpdate$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateCostCenterActions.putIndirectRateCostCenters),
            map(action =>
                IndirectRateCostCenterActions.upsertIndirectRateCostCenters({
                    indirectRateCostCenters: action.indirectRateCostCenters.map(
                        x => ({
                            ...x,
                            Status: {
                                StatusCode: ResponseStatus.Loading,
                                Message: 'Loading'
                            }
                        })
                    )
                })
            )
        );
    });
    putIndirectRateCostCenters$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateCostCenterActions.putIndirectRateCostCenters),
            switchMap(action =>
                this.service
                    .putIndirectRateCostCenters(action.indirectRateCostCenters)
                    .pipe(
                        concatMap(resp =>
                            fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                                ? [
                                      IndirectRateCostCenterActions.upsertIndirectRateCostCenters(
                                          {
                                              indirectRateCostCenters:
                                                  resp.Items
                                          }
                                      ),
                                      new fromShared.Errors.RemoveErrors(
                                          resp.Items.filter(
                                              x =>
                                                  x.Status.StatusCode ===
                                                  ResponseStatus.Success
                                          ).map(x => x.id.toString())
                                      )
                                  ]
                                : [
                                      new fromShared.Errors.SetErrors(
                                          fromShared.Errors.MapErrorsToStatus(
                                              resp
                                          )
                                      ),
                                      IndirectRateCostCenterActions.upsertIndirectRateCostCenters(
                                          {
                                              indirectRateCostCenters:
                                                  resp.Items
                                          }
                                      )
                                  ]
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: IndirectRateService
    ) {}
}
